import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencySymbol' })
export class CurrencySymbolPipe implements PipeTransform {
  public transform(currencyCode: string | null, format: 'wide' | 'narrow' = 'narrow', locale?: string): string {
    return getCurrencySymbol(currencyCode!, format, locale);
  }
}
